<!-- 
    导入标签
    jay 2020-02-28
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar
      :title="$t('recharge.importLabel')"
      :fixed="true"
      left-arrow
      @click-left="navbarback"
    >
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="my-tag">
        <h2 class="tag-title">
          <span>{{ $t("recharge.myLabel") }}</span>
        </h2>
        <div class="tag-list">
          <a
            :class="{ active: tagActive == index }"
            v-for="(item, index) in tagList"
            :key="index"
            @click="chooseTag(index)"
            >{{ item.tag_name }}</a
          >
          <a class="placeholder-item"></a>
          <a class="placeholder-item"></a>
          <a class="placeholder-item"></a>
          <a class="placeholder-item"></a>
        </div>
      </div>
      <div class="button-wrap">
        <van-button block type="primary" @click="userMobiles">
          {{ $t("recharge.confirmImport") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    },
    tagImportMobile: {
      //标签号码
      type: Array,
      default: function() {
        return [];
      }
    },
    tagImportFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    numberIndex: {
      //文本框索引当前索引
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {},
  data() {
    return {
      tagActive: 0 //标签选中
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navbarback() {
      //返回上一页
      this.$emit("update:tagImportFlag", false);
    },
    chooseTag(index) {
      //选择标签
      let vm = this;
      vm.tagActive = index;
    },
    userMobiles() {
      //导入号码
      let vm = this;
      let params = {};
      params.tag = vm.tagList[vm.tagActive].id;
      vm.$post("/app/user/userMobiles", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("userMobiles", res);
        if (res.code == 0) {
          if (res.data.list.length) {
            let arr = [];
            for (let i = 0; i < res.data.list.length; i++) {
              arr.push(res.data.list[i].mobile);
            }
            vm.$emit("update:tagImportMobile", arr);
            vm.$emit("getTagImportMobile", vm.numberIndex, arr);
            vm.navbarback();
          } else {
            vm.$toast(vm.$t("recharge.labelNoNumber"));
          }
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.my-tag {
  padding: 22px;
  .tag-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 400;
  }
  .tag-list {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    a {
      min-width: 78px;
      height: 28px;
      border-radius: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eff2f5;
      color: #4a4a4a;
      font-size: 14px;
      &.active {
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
        color: #fff;
      }
      &.placeholder-item {
        height: 1.1px;
        border-radius: 0;
        background: none;
      }
    }
  }
}
</style>
